<template>
  <div class="text-dark">
    <b-container fluid>
      <div v-if="detailSubscription && isBcaVa && normalizedStatus">
        <b-row align-h="center">
          <b-col xl="5" lg="6" md="8" sm="9" xs="12">
            <!-- Title -->
            <b-row class="mb-1">
              <b-col class="size24 fw-bold-800">
                {{ normalizedStatus === 'pending' ? 'Detail Transaksi' : 'Detail Berlangganan' }}
              </b-col>
            </b-row>

            <!-- ID -->
            <b-row class="mb-2">
              <b-col> ID Transaksi </b-col>
              <b-col class="text-right" :class="{'cursor-pointer': normalizedStatus === 'success'}" @click="normalizedStatus === 'success' && print()">
                <template v-if="normalizedStatus === 'success'">
                  <b-button class="bg-white border-8">
                    {{ detailSubscription.invoice_number }}
                  </b-button>
                </template>
                <template v-else>
                  {{ detailSubscription.invoice_number }}
                </template>
              </b-col>
            </b-row>

            <!-- Status -->
            <b-row class="mb-2">
              <b-col> Status </b-col>
              <b-col class="text-right">
                <span :class="['p-1','rounded-pill','fw-bold-700', statusBadgeClass]">
                  {{ statusLabel }}
                </span>
              </b-col>
            </b-row>

            <!-- Nominal / Total Kredit -->
            <b-row class="mb-2" v-if="amountValue != null">
              <b-col> {{ amountLabel }} </b-col>
              <b-col class="text-right">
                {{ amountValue }}
              </b-col>
            </b-row>

            <!-- Total / Total Tagihan -->
            <b-row class="mb-2">
              <b-col>Total Tagihan </b-col>
              <b-col class="text-right">
                {{ parseFloat(detailSubscription.total) | formatAmount }}
              </b-col>
            </b-row>

            <!-- Metode Pembayaran + VA -->
            <b-row class="mb-2">
              <b-col> Metode Pembayaran </b-col>
              <b-col class="text-right">
                {{ isBcaVa ? 'BCA VA - ' : '' }}{{ detailSubscription.xendit_provider.va_account_number }}
                <feather-icon
                  icon="CopyIcon"
                  class="text-primary cursor-pointer"
                  size="16"
                  @click="copyToClipboard(detailSubscription.xendit_provider.va_account_number)"
                />
                <div v-if="copied" class="badge badge-light-success mt-50">
                  Berhasil disalin!
                </div>
              </b-col>
            </b-row>

            <!-- Waktu Transaksi -->
            <b-row class="mb-2" v-if="detailSubscription.created_at">
              <b-col> Waktu Transaksi </b-col>
              <b-col class="text-right">
                {{ detailSubscription.created_at }}
              </b-col>
            </b-row>

            <!-- Bayar Sebelum / Berlaku Hingga -->
            <b-row class="mb-5" v-if="expireValue">
              <b-col> {{ expireLabel }} </b-col>
              <b-col class="text-right" :class="{'text-danger': normalizedStatus === 'pending'}">
                {{ expireValue }}
              </b-col>
            </b-row>

            <!-- Cara Bayar (only pending + bca_va) -->
            <template v-if="showCaraBayar">
              <b-row class="mb-1">
                <b-col class="size24 fw-bold-800"> Cara Bayar </b-col>
              </b-row>

              <div class="card p-1" v-b-toggle.collapse-1>
                <div class="d-flex align-items-center">
                  <b-img :src="require('/src/assets/images/logo/bca.png')" alt="bca" style="width: 4rem" />
                  <span class="ml-1"> Bank Central Asia - Virtual Account </span>
                  <span class="ml-auto">
                    <feather-icon icon="ChevronDownIcon" size="16" />
                  </span>
                </div>

                <b-collapse id="collapse-1">
                  <hr />
                  <div class="size16 fw-bold-900 ml-1">Melalui ATM</div>
                  <ol>
                    <li>Masukkan kartu ke mesin ATM</li>
                    <li>Masukkan 6 digit PIN Anda</li>
                    <li>Pilih “Transaksi Lainnya”</li>
                    <li>Pilih “Transfer”</li>
                    <li>Lanjut ke “ke Rekening BCA Virtual Account”</li>
                    <li>Masukkan nomor BCA Virtual Account Anda, kemudian tekan “Benar”</li>
                    <li>Masukkan jumlah yang akan dibayarkan, selanjutnya tekan “Benar”</li>
                    <li>Validasi pembayaran Anda. Pastikan detail transaksi sudah benar, lalu pilih “Ya”</li>
                    <li>Pembayaran selesai. Pilih “Tidak” untuk selesai, atau “Ya” untuk transaksi lain</li>
                  </ol>

                  <div class="size16 fw-bold-900 ml-1">Melalui Aplikasi BCA Mobile</div>
                  <ol>
                    <li>Login ke aplikasi BCA Mobile</li>
                    <li>Pilih “m-BCA”, masukkan kode akses</li>
                    <li>Pilih “m-Transfer”</li>
                    <li>Pilih “BCA Virtual Account”</li>
                    <li>Masukkan nomor VA Anda, atau pilih dari Daftar Transfer</li>
                    <li>Masukkan nominal yang dibayarkan</li>
                    <li>Masukkan PIN m-BCA</li>
                    <li>Transaksi berhasil</li>
                  </ol>
                </b-collapse>
              </div>
            </template>
          </b-col>
        </b-row>
      </div>
    </b-container>

    <!-- Tetap ada untuk print, disembunyikan -->
    <InvoiceSubscription :detailSubscription="detailSubscription" class="d-none" />
  </div>
</template>

<script>
import {
  BContainer,
  BRow,
  BCol,
  BImg,
  BButton,
  BCollapse,
  VBToggle,
} from "bootstrap-vue";

import InvoiceSubscription from "@/components/InvoiceSubscription.vue";

export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BImg,
    BButton,
    BCollapse,
    InvoiceSubscription,
  },
  directives: {
    "b-toggle": VBToggle,
  },
  props: {
    detailSubscription: { type: Object, required: true },
  },
  data() {
    return { copied: false };
  },
  computed: {
    // Normalize source fields (xendit_provider vs root)
    normalizedStatus() {
      return (
        this.detailSubscription?.xendit_provider?.payment_status ||
        this.detailSubscription?.payment_status ||
        null
      );
    },
    normalizedMethod() {
      return (
        this.detailSubscription?.xendit_provider?.payment_method ||
        this.detailSubscription?.payment_method ||
        null
      );
    },
    isBcaVa() {
      return this.normalizedMethod === "bca_va";
    },
    statusMeta() {
      // map status -> label & badge class
      const map = {
        pending: { label: "Menunggu Pembayaran", badge: "bg-warning" },
        success: { label: "Aktif", badge: "bg-primary" },
        canceled: { label: "Dibatalkan", badge: "bg-danger text-white" },
        expired: { label: "Kedaluwarsa", badge: "secondary-2 text-white" },
      };
      return map[this.normalizedStatus] || { label: "-", badge: "badge-light" };
    },
    statusLabel() {
      return this.statusMeta.label;
    },
    statusBadgeClass() {
      return this.statusMeta.badge;
    },
    amountLabel() {
      return this.normalizedStatus === "pending" ? "Total Kredit" : "Nominal";
    },
    amountValue() {
      if (this.normalizedStatus === "pending") {
        // uses custom filter formatInvoice
        return this.detailSubscription?.amount != null
          ? this.$options.filters?.formatInvoice
            ? this.$options.filters.formatInvoice(this.detailSubscription.amount)
            : this.detailSubscription.amount
          : null;
      }
      // success/canceled/expired use total_price | formatAmount
      if (this.detailSubscription?.total_price != null) {
        return this.$options.filters?.formatAmount
          ? this.$options.filters.formatAmount(this.detailSubscription.total_price)
          : this.detailSubscription.total_price;
      }
      return null;
    },
    expireLabel() {
      return this.normalizedStatus === "pending" ? "Bayar Sebelum" : "Berlaku Hingga";
    },
    expireValue() {
      return this.detailSubscription?.payment_expired_at || null;
    },
    showCaraBayar() {
      return this.normalizedStatus === "pending" && this.isBcaVa;
    },
  },
  methods: {
    async copyToClipboard(text) {
      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(text);
        } else {
          // fallback
          const textArea = document.createElement("textarea");
          textArea.value = text;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand("copy");
          document.body.removeChild(textArea);
        }
        this.copied = true;
        setTimeout(() => (this.copied = false), 1500);
      } catch (e) {
        // optional: toast error
        this.copied = false;
      }
    },
    async print() {
      const { hostname, protocol, port } = window.location;
      const noLandscapeOptions = {
        name: "_blank",
        specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
        styles: [`${protocol}//${hostname}${port ? `:${port}` : ""}/bootstrap.css`],
        timeout: 1000,
        autoClose: true,
        windowTitle: window.document.title,
      };
      await this.$htmlToPaper("contentPrintSubscription", noLandscapeOptions);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/variables/_variables.scss";

.secondary-2 {
  background-color: $secondary-2;
}
</style>
